import { apiConstants } from '../_constants';
import { authHeader, handleResponse } from '../_helpers';
export const sliderService = {
    sliderList,

};

function sliderList(data) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(apiConstants.apiUrl + "/getsliderlist", requestOptions).then(
        handleResponse
    );
}

